export const searchProspectsSelector = ({ allProspects }) => allProspects;
